export const videoCards = [
    {
      image: 'https://img.youtube.com/vi/ogMyR84BwqI/maxresdefault.jpg',
      alt: 'Summer Top 10 Highlights thumbnail',
      title: 'Summer Top 10 Highlights',
      subtitle: 'Indefinite bragging rights',
      url: 'https://youtu.be/ogMyR84BwqI',
    },
    {
      image: 'https://img.youtube.com/vi/iEEEid2OkD8/maxresdefault.jpg',
      alt: 'Brand Building thumbnail',
      title: 'Brand Building',
      subtitle: "Video matters, we've got you",
      url: 'https://youtu.be/iEEEid2OkD8',
    },
  ];